export const DROPDOWN_SELECT_CLASSES =
  'w-full py-1 pr-7 pl-1.5 text-[11px] leading-4 border border-gray-02 rounded-md bg-white-01 [font-family:var(--font-base)] cursor-pointer transition-colors hover:enabled:border-light-gray-xx focus:outline-none focus:border-[var(--theme-secondary)] focus:shadow-[0_0_0_2px_rgba(52,60,84,0.1)]';

export const DROPDOWN_SELECT_FILLED_TEXT_CLASSES = 'text-[var(--color-gray-07)]';

export const DROPDOWN_SELECT_EMPTY_TEXT_CLASSES =
  'text-[10px] text-[color-mix(in_srgb,var(--color-gray-07)_60%,white)]';

export const DROPDOWN_SELECT_CHEVRON_CLASSES =
  'appearance-none bg-[url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23666%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C/polyline%3E%3C/svg%3E)] bg-no-repeat bg-[right_6px_center] bg-[length:16px]';

// SelectInput sizes its button for the app's forms (px-4 py-2.5 text-sm); the `!` overrides bring
// the fill sheet's closed control down to the builder select (py-1, 11px over a 16px line, 26px
// tall). The single and the multiple fill selects both read these, so their closed buttons cannot
// drift apart.
export const FILL_SELECT_BUTTON_CLASSES =
  '!px-1.5 !pl-1.5 !pr-7 !py-1 !rounded-md bg-white-01 border border-gray-02 whitespace-nowrap cursor-pointer transition-colors hover:enabled:border-light-gray-xx focus:border-[var(--theme-secondary)]';

export const FILL_SELECT_EMPTY_TEXT_CLASSES = '!text-[10px]/4';

export const FILL_SELECT_FILLED_TEXT_CLASSES = '!text-[11px]/4';
